import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SYNC_RECORDINGS } from 'actions/Types';

export default () => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_SYNC_RECORDINGS,
      request: async apiClient => {
        return await apiClient.broadcast.get(teamId, eventId, broadcastId);
      }
    };
    dispatch(action);
  });
};
